// src/components/MobileWrapper.jsx
import React, { useState, useEffect } from 'react';

// Se usará 768px como punto de quiebre para considerar móvil
const MOBILE_BREAKPOINT = 768; 

function MobileWrapper({ DesktopComponent, MobileComponent, ...props }) {
    const [isMobile, setIsMobile] = useState(false); 

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
        };
        
        handleResize(); 
        window.addEventListener('resize', handleResize);
        
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Renderiza la versión móvil si es detectada, de lo contrario, la de escritorio.
    return isMobile ? 
        <MobileComponent {...props} /> : 
        <DesktopComponent {...props} />;
}

export default MobileWrapper;